import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom'; 
import Cookies from 'universal-cookie';


const SuccessPayment = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  console.log("id success: "+  id );  



  useEffect(() => {

  if (id===undefined)
  {
  //alert("الرابط غير صحيح يرجى استخدام ال QR الذي أخذته من ال إدارة");
  }

  }, []);

    const cookies = new Cookies();

   // cookies.set('points1smsssur', user, { path: '/' });
    
  /*
  var user_cookie= cookies.get('points1smsssur'); 
  var pass_cookie= cookies.get('points1smsssprivrw'); 
  */

  const [formData, setFormData] = useState({
    telegramCode: '',
    password: ''
  });
  const [registerData, setRegisterData] = useState({
    fullName: '',
    email: '',
    phone: '',
    age: '',
    gender: '',
    password: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState(''); // ADDED: Success message state
  const [isRegistering, setIsRegistering] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleRegisterChange = (e) => {
    setRegisterData({
      ...registerData,
      [e.target.name]: e.target.value
    });
  };

  // ADDED: Create test Customer function
  const createTestCustomer = async () => {
    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const testCustomer = {
        name: 'أحمد محمد علي',
        email: 'test.Customer@example.com',
        password: 'test123',
        phone: '01098765432',
        age: 30,
        gender: 'male'
      };

      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/customer/register', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify(testCustomer),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(`تم إنشاء العميل التجريبي بنجاح! كود التليجرام: ${data.telegram_code}`);
        setFormData({
          telegramCode: data.telegram_code,
          password: 'test123'
        });
      } else {
        if (response.status === 400 && data.message.includes('مسجل بالفعل')) {
          setError('العميل التجريبي موجود بالفعل - جرب تسجيل الدخول بكلمة المرور: test123');
        } else {
          setError(data.message || 'حدث خطأ في إنشاء العميل التجريبي');
        }
      }
    } catch (err) {
      console.error('Error creating test Customer:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/customer/login', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          telegram_code: formData.telegramCode,
          password: formData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // MODIFIED: Store TokenAs with correct keys
        localStorage.setItem('CustomerTokenA', data.TokenA); // CHANGED: Use CustomerTokenA instead of TokenA
        localStorage.setItem('CustomerData', JSON.stringify(data.Customer)); // CHANGED: Store Customer data instead of separate fields
        
        // ADDED: Debug logging
        console.log('Customer login successful:', data.message);
        console.log('Customer data:', data.Customer);
        
        // Navigate to dashboard
        navigate('/Customer/dashboard');
      } else {
        setError(data.message || 'الكود أو كلمة المرور غير صحيحة');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

    // Validate passwords match
    if (registerData.password !== registerData.confirmPassword) {
      setError('كلمات المرور غير متطابقة');
      setIsLoading(false);
      return;
    }

    // Validate age
    if (registerData.age && (isNaN(registerData.age) || registerData.age < 1 || registerData.age > 120)) {
      setError('يرجى إدخال عمر صحيح');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/customer/register', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          name: registerData.fullName,
          email: registerData.email,
          phone: registerData.phone,
          age: registerData.age ? parseInt(registerData.age) : null,
          gender: registerData.gender || null,
          password: registerData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // MODIFIED: Use success message state instead of alert
        setSuccessMessage(`تم إنشاء حسابك بنجاح! كود التليجرام الخاص بك: ${data.telegram_code} - احفظ هذا الكود لتسجيل الدخول مستقبلاً`);
        
        // ADDED: Auto-fill login form with the new telegram code
        setFormData({
          telegramCode: data.telegram_code,
          password: registerData.password
        });
        
        // Clear form and switch to login
        setRegisterData({
          fullName: '',
          email: '',
          phone: '',
          age: '',
          gender: '',
          password: '',
          confirmPassword: ''
        });
        setIsRegistering(false);
      } else {
        setError(data.message || 'حدث خطأ في إنشاء الحساب');
      }
    } catch (err) {
      console.error('Registration error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };
// 
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500 flex-center"> {/* REVERTED: Back to your original working class */}
      <div className="glass p-8 m-4 w-full max-w-md">
        <div className="text-center mb-8">
          <h1   style={{marginTop: '12px',marginBottom: '12px'}}  className="text-white text-3xl font-bold mb-2">
           تم الدفع بنجاح 
          </h1>
       
        </div>

      
        <div className="mt-6 text-center space-y-3"> {/* ADDED: space-y-3 for better spacing */}
                    <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
           كود الحجز الخاص بك هو: <span style={{ fontWeight: 'bold', fontSize: '18px' }}>{id}</span>
          </p>
          <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
            قبل 15 دقيقة من  الوقت الذي تم حجزه ، يرجى التواجد       
            </p>
       

     

 

        </div>

    
      </div>
    </div>
  );
};

export default SuccessPayment;